<template>
  <div id="main-content" class="cancel-detail">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <template v-if="cancelDetail">
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.full_name') }}:</span>
            <span class="info-span"> {{ cancelDetail.student_info ? cancelDetail.student_info.name : '' }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.romaji') }}:</span>
            <span class="info-span"> {{ cancelDetail.student_info ? cancelDetail.student_info.romaji : '' }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.furigana') }}:</span>
            <span class="info-span"> {{ cancelDetail.student_info ? cancelDetail.student_info.furigana : '' }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.class') }}:</span>
            <span class="info-span">
              {{ cancelDetail.student_info && cancelDetail.student_info.class_info ? cancelDetail.student_info.class_info.name : '' }}
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.bus_stop') }}:</span>
            <span class="info-span">
              {{ cancelDetail.student_info && cancelDetail.student_info.place_info ? cancelDetail.student_info.place_info.name : '' }}
            </span>
          </el-col>
        </el-row>
        <CancelDate :cancelDetail="cancelDetail"
            :cancelType="getCancelType(cancelDetail.type)" v-if="isCancelDate()"></CancelDate>
        <CancelDay :cancelDetail="cancelDetail"
            :cancelType="getCancelType(cancelDetail.type)" v-else-if="isCancelDay()"></CancelDay>
        <CancelPeriod :cancelDetail="cancelDetail"
            :cancelType="getCancelType(cancelDetail.type)" v-else-if="isCancelPeriod()"></CancelPeriod>
        <Booking :bookingDetail="cancelDetail" :cancelType="getCancelType(cancelDetail.type)" v-else></Booking>
      </template>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import CancelDate from "@/components/Schedule/CancelDate"
  import CancelDay from "@/components/Schedule/CancelDay"
  import CancelPeriod from "@/components/Schedule/CancelPeriod"
  import Booking from "@/components/Schedule/Booking"
  import {
    SCHEDULE_CANCEL_DATE,
    SCHEDULE_CANCEL_DAY,
    SCHEDULE_CANCEL_PERIOD,
    SCHEDULE_BOOKING
  } from "@/config"

  export default {
    name: "CancelDetail",
    components: {
      PageTitle,
      CancelDate,
      CancelDay,
      CancelPeriod,
      Booking
    },
    data: function () {
      return {
        title: "",
        backLink: `/schedule/cancel?action=back`,
        cancelDetail: null
      }
    },
    created: function () {
      let type = this.$route.query.type
      this.title = parseInt(type) === SCHEDULE_BOOKING ? 'schedule.booking_information' : 'schedule.cancel_information'
    },
    mounted: function () {
      let successCallback = (response) => {
        this.cancelDetail = Object.assign({}, response.data.data.cancel_info)
      }

      let payload = {
        successCallback,
        id: this.$route.query.id
      }

      this.$store.dispatch('notification/retrieveCancelDetail', payload)
    },
    computed: {

    },
    methods: {
      isCancelDate: function () {
        return this.cancelDetail && this.cancelDetail.type === SCHEDULE_CANCEL_DATE
      },
      isCancelDay: function () {
        return this.cancelDetail && this.cancelDetail.type === SCHEDULE_CANCEL_DAY
      },
      isCancelPeriod: function () {
        return this.cancelDetail && this.cancelDetail.type === SCHEDULE_CANCEL_PERIOD
      },
      getCancelType: function (type) {
        switch (type) {
          case SCHEDULE_CANCEL_DATE:
            return this.$t('schedule.cancel_by_date')
          case SCHEDULE_CANCEL_DAY:
            return this.$t('schedule.cancel_by_day')
          case SCHEDULE_CANCEL_PERIOD:
            return this.$t('schedule.cancel_by_period')
          default:
            return this.$t('schedule.booking')
        }
      }
    }
  }
</script>

<style lang="scss">
  .cancel-detail {
    .content-row {
      .info-span {
        display: block;
        width: calc(100% - 94px);
        text-align: left;
      }
    }
  }
</style>
